export default __webpack_public_path__ + "static/media/deliveredIcon.f8ac4f6f.svg";